import {
  Body,
  CloseIcon,
  Footer,
  Head,
  NoteValue,
  Row,
  Rows,
  RowTitle,
  RowValue,
  Title,
} from "./style";
import Modal from "../../../components/Modal/Modal";
import React, { useEffect } from "react";
import { useApp } from "../../../contexts";
import {
  formatCurrency,
  getGameCurrencyStatistics,
  openApp,
} from "../../../services/app";
import { useNavigate } from "react-router-dom";
import useStateAsync from "use-state-async";
import moment from "moment";
import styled from "styled-components";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DetailBalance = (props) => {
  const { popup, setPopup, T, setUser, setLoading, getCurrency } = useApp();
  const navigate = useNavigate();
  const { type, wallet, id } = props;
  const [row, setRow] = useStateAsync({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    const result = await getGameCurrencyStatistics(id).catch((reason) => null);
    setLoading(false);
    setRow({
      ...(result?.data?.data || {}),
      date: Date.now(),
    });
  };

  const onClose = () => {
    props.onClose();
  };

  const onApp = async () => {
    setLoading(true);
    const url = await openApp({}).catch((reason) => null);
    setLoading(false);
    if (url) {
      window.location.href = url;
    }
  };

  const onDetail = () => {
    navigate(
      `/transaction-history/${type}?code=${
        wallet?.currency_code || ""
      }&walletId=${id}`
    );
  };

  const coinCode = T(wallet?.currency_code || "");

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg onClose={onClose} />
      <Modal.Container onClose={onClose}>
        <ContentWaper>
          <Head>
            <Title>{T("Detail balance")}</Title>
          </Head>
          <Body>
            <Rows>
              <Row>
                <RowTitle onClick={onApp} className={"link"}>
                  {T("Walking reward")}
                </RowTitle>
                <RowValue>
                  {formatCurrency(row?.totalWalkingReward || 0, null, getCurrency())} {coinCode}
                </RowValue>
              </Row>
              <Row>
                <RowTitle>{T("Total deposit")}</RowTitle>
                <RowValue>
                  {formatCurrency(row?.totalDeposit || 0, null, getCurrency())} {coinCode}
                </RowValue>
              </Row>
              <Row>
                <RowTitle onClick={onDetail} className={"link"}>
                  {T("Total converted")}
                </RowTitle>
                <RowValue>
                  {formatCurrency(row?.totalConverted || 0, null, getCurrency())} {coinCode}
                </RowValue>
              </Row>
              <Row>
                <RowTitle>{T("Total bought")}</RowTitle>
                <RowValue>
                  {formatCurrency(row?.totalBought || 0, null, getCurrency())} {coinCode}
                </RowValue>
              </Row>
            </Rows>
            <Rows>
              <Row>
                <RowTitle>{T("Total SZT")}</RowTitle>
                <RowValue>(1) + (2) - (3) - (4)</RowValue>
              </Row>
              <Row>
                <RowTitle>{T("Possible to convert")}</RowTitle>
                <RowValue>(1) - (3)</RowValue>
              </Row>
            </Rows>
            <Row>
              <RowTitle className={"highlight"}>
                {T("Total SZT balance")}
              </RowTitle>
              <RowValue className={"highlight"}>
                {formatCurrency(row?.totalBalance || 0, null, getCurrency())} {coinCode}
              </RowValue>
            </Row>
            <NoteValue>
              {T("*Data get until {TIME}").replace(
                "{TIME}",
                moment(row?.date).format("HH:mm:ss MM/DD/YYYY")
              )}
            </NoteValue>
          </Body>
        </ContentWaper>
      </Modal.Container>
    </Modal>
  );
};
